/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetFulfillmentSchedulingQuoteRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetFulfillmentSchedulingQuoteResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getFulfillmentSchedulingQuote = (request:GetFulfillmentSchedulingQuoteRequest, options?: CashRequestOptions) => post<GetFulfillmentSchedulingQuoteRequest, GetFulfillmentSchedulingQuoteResponse>("/cash-app/local/get-fulfillment-scheduling-quote", request, {...options, rejectOnError: true })